module.exports = __webpack_public_path__ + "static/media/logo.fe2fc353.png";